import * as React from 'react';

import {StarIcon, FxIcon, LoadingIcon} from 'shells/icon';

import {colors} from '../colors/colors';
import type {ColorName} from '../colors/colors';

import styles from './option-with-count.module.css';

export type ListOptionWithCount = {
    value: string;
    label: string;
    favorite?: boolean;
    isFx?: boolean;
    count: number | null | undefined;
    isSyncing?: boolean;
    requiresSync?: boolean;
    __isNew__?: boolean;
    colorName?: ColorName;
    isDisabled?: boolean;
};

type Props = {
    title: string;
    label: string;
    favorite?: boolean;
    isFx?: boolean;
    isSyncing?: boolean;
    count: number | null | undefined;
};

/**
 * Option component for a GraphQL select object that contains
 * a count for each item in the dropdown.
 */
export function OptionWithCount(props: Props) {
    return (
        <div className={styles.option}>
            {props.favorite !== undefined ? (
                <div style={{opacity: props.favorite ? 1 : 0}} className={styles['favorite-icon']}>
                    <StarIcon />
                </div>
            ) : undefined}
            {props.isFx ? (
                <div style={{opacity: props.isFx ? 1 : 0}} className={styles['fx-icon']}>
                    <FxIcon size={19} />
                </div>
            ) : undefined}
            <div className={styles.label}>{props.label}</div>
            {typeof props.count === 'number' && !props.isSyncing ? (
                <div title={props.title} className={styles.count}>
                    {props.count.toLocaleString()}
                </div>
            ) : undefined}
            {props.isSyncing ? (
                <div
                    title='We’re currently processing this audience and it should be ready for sending shortly'
                    style={{opacity: props.isSyncing ? 1 : 0}}
                    className={styles['loading-icon']}
                >
                    <LoadingIcon fill={colors.greyLt} size={19} />
                </div>
            ) : undefined}
        </div>
    );
}
